import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './PillAbortionTestFailed.module.css';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";

export default function PillAbortionTestFailed({ appLanguage }) {
  const [pageState, setPageState] = useState({
    title: '',
    title2: '',
    extraText: '',
    button1: '',
    button2: '',
    icon: '',
    illustration: '',
    selectedChoices: []
  });

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Abor | Test | Result';

    // Direct localStorage reading
    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    // Add inline helper functions
    const getEntryField = (entryId, field, language = appLanguage || 'es-VE') => {
      const entry = entries.find(e => e.sys.id === entryId);
      if (!entry?.fields?.[field]) return '';
      
      const fieldValue = entry.fields[field];
      if (typeof fieldValue === 'object' && fieldValue[language]) {
        return fieldValue[language];
      }
      return fieldValue;
    };

    const getAssetUrl = (assetId, language = appLanguage || 'es-VE') => {
      const asset = assets.find(a => a.sys.id === assetId);
      if (!asset?.fields?.file) return '';
      
      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      return '';
    };

    setPageState((prevState) => ({
      ...prevState,
      title: getEntryField('WDXw4rYHNRUDKZ7KFCZt6', 'title') || '',
      title2: getEntryField('WDXw4rYHNRUDKZ7KFCZt6', 'title2') || '',
      extraText: getEntryField('WDXw4rYHNRUDKZ7KFCZt6', 'extraText') || '',
      button1: getEntryField('WDXw4rYHNRUDKZ7KFCZt6', 'button1') || '',
      button2: getEntryField('WDXw4rYHNRUDKZ7KFCZt6', 'button2') || '',
      icon: getAssetUrl('509AEqxEJDlZ2wD4F7a2mt') || '',
      illustration: getAssetUrl('y3Rd7KceR170l23wC9ZX9') || '',
    }));
  }, [appLanguage]);

  return (
    
    <div className={styles.pageContainer}>
    <TopNavBarNew backgroundColor="#fff" breadcrumbColor="#333" />
    
      {/* Title */}
      <div className={styles.title}>{pageState.title}</div>

      {/* Icon */}
      <img src={pageState.icon} alt="Warning Icon" className={styles.icon} />

      {/* Title2 */}
      <div className={styles.title2}>{pageState.title2}</div>

      {/* Illustration */}
      <img
        src={pageState.illustration}
        alt="Illustration"
        className={styles.illustration}
      />

      {/* Extra Text2 */}
      <div className={styles.extraText2}>{pageState.extraText}</div>

      {/* Buttons */}
      <button
        className={styles.button1}
        onClick={() => history.push('/chat-main')}
      >
        {pageState.button1}
      </button>
      <button
        className={styles.button2}
        onClick={() => history.push('/home')}
      >
        {pageState.button2}
      </button>
      <div className={styles.extraSpace}></div>
      <div className={styles.bottomSpace}></div>
      
      <BottomNavBarNew appLanguage={appLanguage}/>
      </div>
    
  );
}